import api, { TApiResponse, TEntity } from 'src/utils/api'
import { IAgent } from '@obvious.tech/constellation'
import { Entity } from '@obvious.tech/constellation/Entity'

export const getAgentByPassportId = async ({
  passportId,
  token,
}: {
  passportId: string
  token?: string
}): Promise<TApiResponse<TEntity<IAgent>>> => {
  const agents = await api.getResourcesWithFilters<TEntity<IAgent>>(
    Entity.getResource('Agent'),
  )({
    filters: [['passportId', api.Filter.Eq, passportId]],
    token,
  })

  if (agents._tag === 'failure') return agents

  const [agent, ...otherAgents] = agents.data
  if (agent === undefined || otherAgents.length > 0) {
    return {
      _tag: 'failure',
      error: new Error(
        agents.data.length > 1
          ? `Multiple agents match passport id ${passportId}.`
          : `No agent matching passport id ${passportId}.`,
      ),
    }
  }

  return {
    _tag: 'success',
    data: agent,
  }
}
